import { render, staticRenderFns } from "./ProductTypeGroupsNested.vue?vue&type=template&id=06b2f1e4&scoped=true"
import script from "./ProductTypeGroupsNested.vue?vue&type=script&lang=js"
export * from "./ProductTypeGroupsNested.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeGroupsNested.vue?vue&type=style&index=0&id=06b2f1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2f1e4",
  null
  
)

export default component.exports